module.exports = __webpack_public_path__ + "slider-lab.jpg?04f0b0c7a8508ce38e51ab2aba720706";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slider-lab.jpg
// module id = 40
// module chunks = 0